/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: garry彭
 * @LastEditTime: 2023-06-15 11:34:55
 */
import React, { useState } from 'react'
import { Modal, Select, Table } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'

const { Option } = Select

export default ({ visible, customers, handleImport, onClose, onConfirm }) => {
  const [noOwnHandleWay, setNoOwnHandleWay] = useState(1)

  const columns = [
    {
      title: '序号',
      dataIndex: 'id'
    },
    {
      title: '客户名称',
      dataIndex: 'customerName'
    },
    {
      title: '跟进人电话',
      dataIndex: 'ownerMobiles',
      render: (ownerMobiles) => ownerMobiles.join('<br/>')
    }
  ]

  const handleClose = () => {
    setNoOwnHandleWay(1)
    onClose()
  }

  const handleConfirm = () => {
    handleImport(noOwnHandleWay).then((data) => {
      if (data.status === 2) {
        Modal.error({
          title: data.msg
        })
      } else {
        Modal.success({
          title: '导入成功',
          onOk: onConfirm
        })
      }
    })
  }

  return (
    <Modal
      title="以下客户无法设置跟进人"
      open={visible}
      getContainer={false}
      onCancel={handleClose}
      onOk={handleConfirm}
    >
      <div className="owner-config-container">
        <div className="tip">
          <InfoCircleOutlined className="info-icon" />
          跟进人电话无法匹配到团队内成员，无法为以下客户设置跟进人
        </div>

        <Table
          pagination={false}
          dataSource={customers}
          columns={columns}
          rowKey="id"
          scroll={{
            x: '100%',
            y: 300,
            scrollToFirstRowOnChange: true
          }}
        />

        <div className="action">
          处理方式：
          <Select
            value={noOwnHandleWay}
            onChange={(value) => setNoOwnHandleWay(value)}
            style={{ width: 200 }}
          >
            <Option value={1}>设置跟进人为我</Option>
            <Option value={2}>忽略这些客户</Option>
          </Select>
        </div>
      </div>
    </Modal>
  )
}
